import { defineMessages } from 'react-intl-next';

export default defineMessages({
    askAtlassianIntelligence: {
        defaultMessage: 'Ask Atlassian Intelligence',
        description: 'Text for atlassian intelligence choice on search',
        id: 'search.portals.unified.help.ask.atlassian.intelligence.non-final',
    },
    showAllResults: {
        defaultMessage: 'Show all results',
        description: 'Text for searching on all results choice',
        id: 'search.portals.unified.help.show.all.results.non-final',
    },
    inputPlaceholder: {
        defaultMessage: 'Ask Atlassian Intelligence anything...',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.portals.unified.help.input.placeholder.non-final',
    },
});
